import { about } from '@/content/et/about';
import { site } from '@/content/et/site';
import styles from './AboutStrip.module.css';

export function AboutStrip() {
  return (
    <section className="section" aria-labelledby="about-title">
      <div className="container">
        <header className="section__header">
          <h2 id="about-title" className="section__title section__title--tight">
            {site.about.title}
          </h2>
        </header>

        <div className={styles.grid}>
          <div className={styles.copy}>
            {about.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
          <ul className={styles.footnotes}>
            {about.callouts.map((c, i) => (
              <li key={c}>
                <span className={styles.fnMark} aria-hidden="true">
                  *{i + 1}
                </span>
                {c}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
